module.exports = __webpack_public_path__ + "static/media/user_icon.2ad3b94e.svg";